import React, {Component, Fragment} from 'react';
import DEFINE, {HOTEL as ENUM_HOTEL, PATHS, FEATURE_FLAGS} from "../../../../constants/Define";
import {Link} from 'react-router-dom';
import * as Func from '../../../../helpers/functions';
import * as HMS from "../../common/component/Index";
import CategoryList from './CategoryList';
import Ripple from '../../common/component/Ripple';

let permisionActions = [];
export default class Categories extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filters: {
                pageSize: this.props.categoryState.pageSize,
                pageIndex: this.props.categoryState.pageIndex,
            },
        };
    }

    componentDidMount() {
        permisionActions = Func.getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.CATEGORY);
        this.props.getListCategories(this.state.filters);
    }

    render() {
        const {t} = this.props;
        const {isFetching, totalCount, totalPage, pageIndex, pageSize, categories} = this.props.categoryState;
        const pagination = {totalCount, totalPage, defaultCurrent: pageIndex, pageSize};
        return (
            <Fragment>
                <HMS.PageListComponent onChangeLanguage={FEATURE_FLAGS.TRANSLATE_ENABLE && this.onChangeLanguage}>
                    <HMS.HeaderListComponent
                        path={this.props.match.path}
                        groupPath={'categories'}
                        titleHeader={t('navigation.categories')}
                        componentRight={
                            <Fragment>{
                                permisionActions && permisionActions.allowCreate &&
                                <Ripple color="rgba(255, 255, 255, 0.8)" waitForEffect={true}>
                                    <Link to={PATHS.CATEGORY.CREATE.path}
                                          className='btn btn-primary'>+ {t(`action.create`)}</Link>
                                </Ripple>
                            }
                            </Fragment>
                        }
                    />
                    <CategoryList loading={isFetching}
                                  permisions={permisionActions}
                                  categories={categories}
                                  pagination={pagination}
                                  onChange={this.onTableChange}
                                  onDeleteCategory={this.onDeleteCategory}
                    />
                </HMS.PageListComponent>
            </Fragment>
        );
    }

    onTableChange = (pagination, filters, sorter) => {
        let newFilters = Func.genaratePaginateFilterSort(pagination, filters, sorter);
        this.setState({
            filters: newFilters
        });
        this.props.getListCategories(newFilters);
    };

    onDeleteCategory = (item) => {
        this.props.deleteCategoryDetail(item, {
            filters: {
                pageSize: this.props.categoryState.pageSize,
                pageIndex: this.props.categoryState.pageIndex
            }
        });
    }

    onChangeLanguage = (language) => {
        this.props.getListCategories(this.state.filters)
    }
}
